<template>
  <b-row>
    <b-col
      cols="12"
      sm="6"
    >
      <DatePicker
        label="Desde: "
        v-model="filters.dateStart"
      />
    </b-col>
    <b-col
      cols="12"
      sm="6"
    >
      <DatePicker
        label="Hasta"
        v-model="filters.dateEnd"
      />
    </b-col>
    <b-col
      cols="12"
      sm="6"
    >
      <Select2
        label="Empleado: "
        reduce
        :options="employeesOp"
        v-model="filters.employee"
      />
    </b-col>
    <b-col
      cols="12"
      sm="6"
    >
      <Select2
        label="Tipo de Descuento: "
        reduce
        :options="discountTypesOp"
        v-model="filters.discountType"
      />
    </b-col>
    <b-col
      cols="12"
      class="text-right"
    >
      <b-button
        size="sm"
        variant="info"
        class="mt-4 mr-1"
        @click="$emit('search')"
      >
        <i class="fas fa-search mr-1 "/> Filtrar
      </b-button>
      <b-button
        size="sm"
        variant="dark"
        class="mt-4 ml-1"
        @click="$emit('clear')"
      >
        <i class="fas fa-ban mr-1" /> Limpiar
      </b-button>
    </b-col>
  </b-row>
</template>
<script>
import { defineComponent } from '@vue/composition-api'

// components
import { DatePicker, Select2 } from '@/components/general'

// hooks
import { useEmployeesOp, useDiscountType } from '@/hooks'

export default defineComponent({
  name: 'FiltersDiscountControl',
  components: {
    Select2,
    DatePicker
  },
  props: {
    filters: {
      type: Object,
      required: true
    }
  },
  setup () {
    const { employeesOp } = useEmployeesOp()
    const { discountTypesOp } = useDiscountType()

    return {
      employeesOp,
      discountTypesOp
    }
  }
})
</script>
